<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import CurriculumLink from './CurriculumLink.vue';

const props = defineProps({
	games: { type: Array, default: () => [] },
	selectedGameId: { type: String, default: 'g0' },
	selectGame: { type: Function, required: true },
	user: { type: Object, required: true },
	windowWidth: { type: Number, required: true },
	handleArticleAction: { type: Function, required: true },
	savedOnly: { type: Boolean, default: false },
});

const collapsed = ref(new Set());
const swipedGameId = ref(null);
const selectedGame = computed(() => games.value.flatMap(category => category.articles || []).find(game => game.id === props.selectedGameId));
const games = computed(() => props.games);
const savedGames = computed(() => games.value.flatMap(category => (category.articles || []).map(game => ({ game, category })))
	.filter(({ game }) => !game.overview && props.user?.training?.[game.id]?.saved));
function setSwipedGame(id) {
	swipedGameId.value = id;
}
function toggleCategory(id) {
	const next = new Set(collapsed.value);
	if (next.has(id)) next.delete(id);
	else next.add(id);
	collapsed.value = next;
}
function activateFocusedGame(event) {
	if (event.key !== 'Enter') return;
	const element = document.activeElement;
	if (element?.hasAttribute('data-id')) element.click();
}
onMounted(() => document.addEventListener('keydown', activateFocusedGame));
onUnmounted(() => document.removeEventListener('keydown', activateFocusedGame));
</script>

<template>
	<template v-if="savedOnly">
		<details v-if="savedGames.length" open class="category-list-section">
				<summary><h3>Games</h3></summary>
				<CurriculumLink
					v-for="{ game, category } in savedGames"
					:key="game.id"
					:article="game"
					:section="category"
					:currentArticle="selectedGame"
					:user="user"
					:openArticle="selectGame"
					:windowWidth="windowWidth"
					:swipedArticleId="swipedGameId"
					:setSwipedArticle="setSwipedGame"
					:handleArticleAction="handleArticleAction"
					:gameMode="true"
				/>
		</details>
	</template>
	<div v-else id="games-curriculum" class="category-list">
		<template v-for="category in games" :key="category.id">
		<details :open="!collapsed.has(category.id)" class="category-list-section">
			<summary @click.prevent="toggleCategory(category.id)"><h3>{{ category.label }}</h3></summary>
			<CurriculumLink
				v-for="game in category.articles"
				:key="game.id"
				:article="game"
				:section="category"
				:currentArticle="selectedGame"
				:user="user"
				:openArticle="selectGame"
				:windowWidth="windowWidth"
				:swipedArticleId="swipedGameId"
				:setSwipedArticle="setSwipedGame"
				:handleArticleAction="handleArticleAction"
				:gameMode="true"
			/>
		</details>
		<CurriculumLink
			v-if="category.articles.some(game => game.id === selectedGameId)"
			:article="selectedGame"
			:section="category"
			:currentArticle="selectedGame"
			:user="user"
			:openArticle="selectGame"
			:windowWidth="windowWidth"
			:swipedArticleId="swipedGameId"
			:setSwipedArticle="setSwipedGame"
			:handleArticleAction="handleArticleAction"
			:gameMode="true"
			class="duplicate-active-link"
		/>
		</template>
		<footer class="category-list-footer"><p>That's all of 'em</p></footer>
	</div>
</template>

<style lang="scss" scoped></style>
